import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GridApi } from 'ag-grid-community';
import { catchError, map } from 'rxjs/operators';
import { TimeEntryModel } from '../models/TimeEntry.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TitleCasePipe } from '@angular/common';
import { URLPaths } from '../utilities/urlPaths.config';
import { ApiheaderService } from './apiheader.service';
import { commonFunctions } from '../classes/common.class';
import { ErrorHandlerService } from './error-handler.service';
import { DateUtility } from '../utilities/date.utility';
import { throwError } from 'rxjs';
import {  HttpHeaders } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class SustainabilityEntryService {

  constructor(private http: HttpClient) {}
 updateEntry(entry: any, month: number, year: number, loginName: string): Observable<any> {
  const headers = ApiheaderService.getHeaders();

  const params = new HttpParams()
    .set('month', month.toString())
    .set('year', year.toString())
    .set('loginName', loginName);

  const travelId = entry.travel_id || 0;
  const url = `${URLPaths.URL_SUSTAINABILITY_ENTRY}${travelId}/`;

  return this.http.put(url, entry, { headers, params });
}


  getSustainabilityData(months: string[], loginName: string): Observable<any> {
  let params = new HttpParams();
  loginName = loginName.trim();

  months.forEach(month => { 
    params = params.append('yearMonths', month);
  });

  params = params.set('loginName', loginName);

  const headers = ApiheaderService.getHeaders();

  return this.http.get<any>(URLPaths.URL_SUSTAINABILITY_ENTRY, {
    params,
    headers
  }).pipe(
    map((response) => {
      return response;
    }),
    catchError((error) => {
      console.error('Error fetching sustainability data:', error);
      return throwError(error);
    })
  );
}

  saveEntries(entries: any[]) {
    const payload = { save_sustainability_entries: entries };


    return this.http.post(URLPaths.URL_SUSTAINABILITY_ENTRY, payload,{ headers: ApiheaderService.getHeaders() });

  }
  deleteEntries(travelIds: number[], month: number, year: number, loginName: string) {
  const headers = ApiheaderService.getHeaders();
  const travelIdParam = travelIds.join(',');

  const params = {
    month: month.toString(),
    year: year.toString(),
    loginName: loginName
  };
  return this.http.delete(`${URLPaths.URL_SUSTAINABILITY_ENTRY}${travelIdParam}/`, {
    headers,
    params
  });
}


updateMultipleEntries(entries: any[]) {
  if (!entries.length) {
    console.warn('No entries provided to updateMultipleEntries()');
    return;
  }

  const headers = ApiheaderService.getHeaders();
  const { month, year, login_name } = entries[0];
  const params = new HttpParams()
    .set('month', month.toString())
    .set('year', year.toString())
    .set('loginName', login_name);

  const travelIds = entries.map(e => e.travel_id).join(',');
  const url = `${URLPaths.URL_SUSTAINABILITY_ENTRY}${travelIds}/`;
  return this.http.put(url, entries, { headers, params });
}
}
